import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Single source of truth for the national guide cluster. Each page passes
// its own slug to exclude itself; the rest render as "related guides" for
// internal interlinking and topical authority.
export const NATIONAL_GUIDES = [
  { to: '/cost-to-build-a-house-australia', title: 'Cost to build a house in Australia', blurb: 'National 2026 per-m² bands and example homes.' },
  { to: '/how-to-build-a-home', title: 'How to build a home', blurb: 'The eight stages, start to handover.' },
  { to: '/renovation-costs-australia', title: 'Renovation costs in Australia', blurb: 'Kitchen, bathroom, whole-home and extension ranges.' },
  { to: '/knockdown-rebuild-explained', title: 'Knockdown rebuild explained', blurb: 'Process, timeline and when it beats renovating.' },
  { to: '/first-home-buyer-guide-australia', title: 'First home buyer guide', blurb: 'Grants, schemes and the first steps.' },
  { to: '/granny-flat-costs-australia', title: 'Granny flat costs in Australia', blurb: 'Kit vs built-on-site, and what drives the price.' },
];

const NationalRelatedGuides = ({ currentSlug }) => {
  const related = NATIONAL_GUIDES.filter((g) => g.to !== currentSlug);
  return (
    <section className="bg-white border-t border-gray-100" data-testid="national-related-guides">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h2 className="text-[22px] sm:text-[28px] font-bold text-[#1d1d1f] tracking-tight mb-6">Related national guides</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {related.map((g) => (
            <Link
              key={g.to}
              to={g.to}
              className="group bg-[#fafbfc] border border-gray-200 rounded-2xl p-5 hover:border-[#1d1d1f] transition-all flex flex-col"
              data-testid={`related-guide-${g.to.replace(/^\//, '')}`}
            >
              <h3 className="text-[15.5px] font-bold text-[#1d1d1f] leading-[1.3] mb-1.5 group-hover:text-[#1d8efe] transition-colors">{g.title}</h3>
              <p className="text-[13px] text-[#86868b] leading-[1.5] mb-4 flex-1">{g.blurb}</p>
              <span className="inline-flex items-center gap-1 text-[12.5px] font-medium text-[#1d1d1f] group-hover:text-[#1d8efe] transition-colors">
                Read guide <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NationalRelatedGuides;
